import { useMemo } from 'react';

import { AcresFeatureFlags } from '@/constants/constants';
import { TileConfig } from '@/models/tileConfig';
import { useInitializeContext } from '@/providers/InitializeProvider';

/**
 * This hook fetches the `TileConfig` from FeatureHub and does the parsing to build the URL's
 * for each of the tiles
 * @returns
 */
export const useTileConfig = () => {
  const { getFeature } = useInitializeContext();
  const rawTileConfig = getFeature(AcresFeatureFlags.TILE_CONFIG) as TileConfig;

  /** A map that maps the key to the corresponding tile URL */
  const tileConfig: TileConfig | null = useMemo(() => {
    if (!rawTileConfig) return null;

    return rawTileConfig as TileConfig;
  }, [rawTileConfig]);

  return {
    tileConfig,
  };
};
